const DATA_TABLE_TAGS = ['th', 'thead', 'caption'];
const INTERACTION_TAGS = ['textentryinteraction', 'inlinechoiceinteraction'];

const hasDescendant = (node, tagNames) =>
    (node.children || []).some(
        (child) => child.type === 'tag' && (tagNames.includes(child.name) || hasDescendant(child, tagNames)),
    );

export const isLayoutTable = (node) => {
    const attribs = node.attribs || {};
    return (
        !attribs.role &&
        !attribs.summary &&
        !hasDescendant(node, DATA_TABLE_TAGS) &&
        !hasDescendant(node, INTERACTION_TAGS) &&
        hasDescendant(node, ['img'])
    );
};

export const markLayoutTable = (node) => {
    if (isLayoutTable(node)) {
        node.attribs = { ...node.attribs, role: 'presentation' };
    }
    return node;
};
